var Validation = (function () {
  

  Utility.log('Validation.js loaded');

  var invalidValueText = 'Please enter a valid ';
  var errorsCount = 0;
  var numberPattern = '[0-9]';
  var a = [];
  var valueMissingMessage = 'Please fill out this field';

  function init() {
    validateForms();
    ios();
    checkEmpty();
  }

  function validateForms() {
    var formValidate = $('.acr-form-validate');
    var formValidateInput = formValidate.find('input');

    formValidate.on('submit', validateForm);
    formValidateInput.on('keypress', onKeypress);
    formValidateInput.on('keyup', onKeyup);
    formValidateInput.on('focus', onFocus);
    formValidateInput.on('blur', onBlur);
  }

  function validateForm(e) {

    errorsCount = 0;

    $('input, select, checkbox', e.target).each(validateField);

    if (errorsCount > 0) {

      $(this).addClass('acr-form-error');
      e.preventDefault();

      return false;

    }

    $(this).removeClass('acr-form-error');


    return true;
  }

  function validateField(index, element) {

    if (element.id === 'cta-search-term' || element.id === 'nav-search') {
      if (element.value.indexOf('<') > -1) {
        element.value = element.value.replace(/</g, '');
      }
    }

    var pattern = element.getAttribute('pattern');
    var modifier = element.dataset.patternModifier;
    var regExp = new RegExp(pattern, modifier);

    if (element.required || element.value.replace(/\s+/g, '').length > 0) {

      if (pattern && regExp.test(element.value) === false) {

        setError(element);

      } else if (!pattern && !element.validity.valid) {

        setError(element);

      } else {
        $(element)
          .parents('.acr-form-element')
          .removeClass('acr-form-element-error')
          .children('.acr-error')
          .text('');

      }
    }
  }

  function setError(element) {

    var errorText;

    if (element.validity.valueMissing) {

      errorText = (element.dataset.missingText)
        ? element.dataset.missingText
        : valueMissingMessage;
    }

    if (!errorText) {
      errorText = element.dataset.errorText;
    }

    if (!errorText) {
      errorText = invalidValueText;
      errorText += $(element)
        .parents('.acr-form-element')
        .children('label')
        .text();
    }

    $(element)
      .parents('.acr-form-element')
      .addClass('acr-form-element-error')
      .children('.acr-error')
      .text('*' + errorText);

    errorsCount++;
  }

  function onKeypress(e) {
    var type = this.getAttribute('type');
    var maxlength = this.getAttribute('maxlength');
    var keyCode = e.keyCode ? e.keyCode : e.which;
    var char = String.fromCharCode(keyCode);
    var regExp;

    if (keyCode !== 8 && keyCode !== 13) {
      if (type === 'number') {
        regExp = new RegExp(numberPattern);

        if ((maxlength && this.value.length > (maxlength - 1))
          || e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) {

          e.preventDefault();
        }
      }

      if ((regExp && !regExp.test(char))) {

        e.stopPropagation();
        e.preventDefault();

        if ($('html').hasClass('ie')) {
          var _this = this;
          setTimeout(function () {
            $(_this).val('');
          }, 300);
        }
      }
    }
  }

  function onKeyup(e) {
    var type = this.getAttribute('type');
    var maxlength = this.getAttribute('maxlength');
    var char = String.fromCharCode(e.keyCode);
    var regExp;

    if (e.keyCode !== 8 && e.keyCode !== 13) {
      if (type === 'number') {
        regExp = new RegExp(numberPattern);

        if ($('html').hasClass('appleios') && this.value === '') {
          this.value = '';
        }
      }
    }
  }

  function onFocus(e) {
    $(this).addClass('acr-not-empty');
  }

  function onBlur(e) {
    if (this.value.length === 0) {
      $(this).removeClass('acr-not-empty');
    }
  }

  function ios() {
    if ($('html').hasClass('appleios')) {
      $('input[type=number]').attr('pattern', '[0-9]*');
    }
  }

  function checkEmpty() {
    var $inputElements = $('.acr-error~input');
    $inputElements.each(function (index, element) {
      var $input = $(element);
      if ($input.val()) {
        $input.addClass('acr-not-empty');
      }
    });
  }

  function isValidEmail(email) {
    var regExp = new RegExp(/^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/);
    return regExp.test(email);
  }


  return {
    init: init,
    invalidValueText: invalidValueText,
    validateForm: validateForm,
    onKeypress: onKeypress,
    onKeyup: onKeyup,
    onFocus: onFocus,
    onBlur: onBlur,
    isValidEmail: isValidEmail,
  };
}());
